export interface SubmitResult {
  ok: boolean;
  message: string;
}

export async function postForm(url: string, form: HTMLFormElement, honeypotName: string): Promise<SubmitResult> {
  const formData = new FormData(form);

  const honeypot = String(formData.get(honeypotName) ?? "").trim();
  if (honeypot) {
    // Silently treat as generic success so bots get no clear signal.
    return { ok: true, message: "" };
  }
  formData.delete(honeypotName);

  const body = new URLSearchParams();
  formData.forEach((value, key) => {
    body.append(key, typeof value === "string" ? value : value.name);
  });

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  });

  const responseText = await response.text();
  let parsed: any = null;
  try {
    parsed = JSON.parse(responseText);
  } catch {
    parsed = null;
  }

  const serverMsg =
    parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
  const spam = /spam/i.test(String(serverMsg));
  const success = response.ok && parsed?.code === "OK" && !spam;

  if (success) {
    return { ok: true, message: serverMsg || "提交成功" };
  }
  return { ok: false, message: String(serverMsg) || "提交失败，请稍后重试" };
}